// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"ec789054","453":"e590fa87","551":"5277b160"}[chunkId] + ".chunk.js";
};